module.exports = __webpack_public_path__ + "static/media/3.d5eff3b8.png";